export const CHECKOUT_URL = 'https://ev-hybrid-diagnostic-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/sDxQFKRfyi1zN1yB4usXqz/Diseno-sin-titulo-7-3.webp'

export const PRODUCT_NAME = 'EV & HYBRID DIAGNOSTIC PRO™'
